import { store as reduxStore } from 'index'

interface RouterConfig {
  menu: any
  router: any
  config: any
}

interface ConfigMap {
  [key: string]: RouterConfig
}

const configMap: ConfigMap = {}

export default async function routerConfigFunc(): Promise<RouterConfig> {
  const { user } = reduxStore.getState()

  const appType = user.role

  if (configMap[appType] == null) {
    const config: RouterConfig = {} as RouterConfig

    // console에서는 workspace.role을 기준으로 구분.
    switch (appType) {
      default:
        config.menu = await import('./default/menu')
        config.router = await import('./default/router')
        config.config = await import('./default/config')
      // default:
      //   config.menu = () => []
      //   config.router = () => []
      //   config.config = {
      //     defaultPage: '/',
      //   }
    }

    configMap[appType] = config
  }

  return configMap[appType]
}
